export const SCENARIO_CHANGED_EVENT = 'cb:scenario-changed';
